export const layers = {
  base: 0,
  gridResizer: 10,
  popup: 1000,
  modal: 2000,
  tooltip: 3000,
};
